import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import AssetsSearchFilter from "./AssetsSearchFilter";
import AssetsTable from "./AssetsTable";
import { Link } from "react-router-dom";
import AddAssetpopup from "../../../../components/modelpopup/Assets/AddAssetpopup";
import AssignAssetPopup from "../../../../components/modelpopup/Assets/AssignAssetPopup";
import AssignReturnAssetPopup from "../../../../components/modelpopup/Assets/AssignReturnAssetPopup";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import moment from "moment";
import { Table, Button } from "antd";
import SearchBox from "../../../../components/SearchBox";

const AssetsList = () => {
  const [assets, setAssets] = useState([]);
  const [employees, setEmployees] = useState([]); // Store employees
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const maximizeBtnRef = useRef(null);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const [popupMode, setPopupMode] = useState("Assign"); // Track the popup mode
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [isAssigning, setIsAssigning] = useState(false);
  const [isReturning, setIsReturning] = useState(false);
  const [assignModalOpen, setAssignModalOpen] = useState(false); // Add this line to manage Assign modal
  // Toggle Fullscreen Mode
  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        setIsFullScreen(true);
      } else {
        document.exitFullscreen();
        setIsFullScreen(false);
      }
    };

    const maximizeBtn = maximizeBtnRef.current;
    maximizeBtn.addEventListener("click", handleClick);

    return () => maximizeBtn.removeEventListener("click", handleClick);
  }, []);


  const handleAssignClick = (asset) => {
    setSelectedAsset(asset);
    setAssignModalOpen(true); // Open the assign modal
   
  };
  
  const handleReturnClick = (asset) => {
    setSelectedAsset(asset);
    setPopupMode("Return");
    setIsPopupOpen(true);
  };

  // Fetch assets data from API
  const fetchAssets = async () => {
    try {
      const response = await axios.get(`${apiUrl}/assets/assets`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setAssets(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching assets:", error);
      toast.error("Failed to fetch assets. Please try again later.");
      setLoading(false);
    }
  };

  // Fetch employees data from API
  const fetchEmployees = async () => {
    try {
      const response = await axios.get(`${apiUrl}/employees/list?listtype=basic`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setEmployees(response.data.employees); // Store employees in state
    } catch (error) {
      console.error("Error fetching employees:", error);
      toast.error("Failed to fetch employees. Please try again later.");
    }
  };

  // Fetch assets and employees on component mount
  useEffect(() => {
    if (apiUrl && token) {
      fetchAssets();
      fetchEmployees();
    }
  }, [apiUrl, token]);

  // Refresh data every 5 seconds
// Fetch assets and employees on component mount


  // Handle asset saving (add or update)
  const handleSave = (asset) => {
    if (isEditing) {
      setAssets((prevAssets) => prevAssets.map((a) => (a.id === asset.id ? asset : a)));
    } else {
      setAssets((prevAssets) => [...prevAssets, asset]);
    }
    setIsEditing(false);
    setSelectedAsset(null);
  };

  // Open edit mode
  const handleEditClick = (asset) => {
    setSelectedAsset(asset);
    setIsEditing(true);
  };

  // Open add mode
  const handleAddClick = () => {
    setIsEditing(false);
    setSelectedAsset(null);
  };

  // Handle delete confirmation
  const handleDeleteClick = async (assetId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this asset!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${apiUrl}/assets/asset/${assetId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setAssets((prevAssets) => prevAssets.filter((asset) => asset.id !== assetId));
        toast.success("Asset has been deleted.");
      } catch (error) {
        Swal.fire("Error!", "Failed to delete asset. Please try again later.", "error");
      }
    }
  };

  const columns = [
    {
      title: "Asset ID",
      dataIndex: "serial_number",
      key: "serial_number",
      sorter: (a, b) => a.serial_number.localeCompare(b.serial_number),
    },
    {
      title: "Asset Name",
      dataIndex: "model",
      key: "model",
      sorter: (a, b) => a.model.localeCompare(b.model),
    },
    {
      title: "Manufacturer",
      dataIndex: "manufacturer",
      key: "manufacturer",
      sorter: (a, b) => a.manufacturer.localeCompare(b.manufacturer),
    },
    {
      title: "Purchase Date",
      dataIndex: "purchase_date",
      key: "purchase_date",
      render: (date) => moment(date).format("MMM DD, YYYY"),
      sorter: (a, b) => new Date(a.purchase_date) - new Date(b.purchase_date),
    },
    {
      title: "Warranty Period",
      dataIndex: "warranty_period",
      key: "warranty_period",
    },
    {
      title: "Assigned to",
      dataIndex: "assigned_user_name",
      key: "assigned_user_name",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const displayStatus = status ? status : "available"; // Default to "available" if status is null or empty
        return (
          <span className={`badge ${displayStatus === "available" ? "bg-success" : "bg-warning"}`}>
            {displayStatus.charAt(0).toUpperCase() + displayStatus.slice(1)}
          </span>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div className="dropdown dropdown-action text-center">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-center">
            <Link
              onClick={() => handleEditClick(record)}
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#add_edit_asset"
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
         
            <Link
            onClick={() => setSelectedAsset(record)} // Set the selected asset here
            className="dropdown-item"
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#assign_asset"
          >
            <i className="fa fa-user-plus m-r-5" /> Assign
          </Link>


          {record.assigned_user_name && (
            <Link
              onClick={() => handleReturnClick(record)}
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#assign_return_asset"
            >
              <i className="fa fa-undo m-r-5" /> Return
            </Link>
          )}
            <button
              className="dropdown-item"
              onClick={() => handleDeleteClick(record.id)}
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </button>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
          <div className="row align-items-center">
              <div className="col-md-4">
                <h3 className="page-title">Assets</h3>
              </div>
              <div className="col-md-8 float-end ms-auto">
                <div className="d-flex title-head">
                  <div className="view-icons">
                    <Link to="#" className="grid-view btn btn-link"><i className="las la-redo-alt" /></Link>
                    <Link to="#" className="list-view btn btn-link" id="collapse-header" ref={maximizeBtnRef}><i className="las la-expand-arrows-alt" /></Link>
                  </div>
                  <Link to="#" className="btn add-btn custom-btn" onClick={handleAddClick} data-bs-toggle="modal" data-bs-target="#add_edit_asset">
                    <i className="la la-plus-circle custom-icon" /> Add New
                  </Link>     
                </div>
              </div>
            </div>

          </div>
          <div className="row">
            <div className="col-md-12">
              {loading ? (
                <div id="loader-wrapper">
                  <div className="loader">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                </div>
              ) : (
                <div className="table-responsive">
                  <SearchBox />
                  <Table
                    className="table-striped"
                    columns={columns}
                    dataSource={assets}
                    rowKey={(record) => record.id}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
     
      <AddAssetpopup
  onSave={handleSave}
  asset={selectedAsset} // Pass selectedAsset as asset
  isEditMode={isEditing} // Pass isEditing as isEditMode
  users={employees} // Pass employees as users to AddAssetpopup
  onClose={() => {
    setIsEditing(false);
    setSelectedAsset(null);
  }}
/>

<AssignAssetPopup
  asset={selectedAsset}
  onClose={() => setSelectedAsset(null)}
  onAssign={(updatedAsset) => {
    setAssets((prevAssets) => prevAssets.map((a) => (a.id === updatedAsset.id ? updatedAsset : a)));
  }}
  users={employees}
/>


        <AssignReturnAssetPopup
          asset={selectedAsset}
          onClose={() => setIsPopupOpen(false)}
          onSave={handleSave}
          users={employees}
          mode={popupMode} // Pass mode for either Assign or Return
        />
    

    </>
  );
};

export default AssetsList;
